var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-col",
    { staticClass: "ma-0 pa-0", attrs: { cols: "12" } },
    [
      _c(
        "v-row",
        { staticClass: "ma-0 pa-0", attrs: { justify: "space-between" } },
        [
          _c(
            "v-col",
            {
              staticClass: "ma-0 pa-0 mt-4 mb-2",
              staticStyle: { "font-weight": "bold" },
              attrs: { cols: "auto", align: "left" },
            },
            [_vm._v(" " + _vm._s(_vm.item.customerName) + " ")]
          ),
        ],
        1
      ),
      _c(
        "v-row",
        { staticClass: "ma-0 pa-0", attrs: { align: "start" } },
        [
          _vm.item.numberOfUas == 0 || !_vm.authorities.GET_STORE_GROUP
            ? _c(
                "v-col",
                { staticClass: "ma-0 pa-0", attrs: { id: "data_box" } },
                [
                  _c("v-row", {
                    staticClass: "ma-0 pa-0",
                    staticStyle: { height: "11.45rem" },
                  }),
                ],
                1
              )
            : _vm.item.numberOfUas != 0 && _vm.authorities.GET_STORE_GROUP
            ? _c(
                "v-col",
                {
                  staticClass: "ma-0 pa-0",
                  staticStyle: { cursor: "pointer", height: "11.45rem" },
                  attrs: { id: "data_box", cols: "3" },
                  on: {
                    click: function ($event) {
                      return _vm.goStoreAnalyze(_vm.item)
                    },
                  },
                },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "ma-0 pa-3 pl-5 pr-5",
                      attrs: { cols: "12" },
                    },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "ma-0 pa-0 mb-1",
                          attrs: { cols: "12" },
                        },
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "ma-0 pa-0",
                              staticStyle: { "font-weight": "bold" },
                              attrs: {
                                align: "center",
                                justify: "space-between",
                              },
                            },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "ma-0 pa-0",
                                  attrs: { id: "data_sub_title", cols: "auto" },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.tsc("last30DaysVisitors")) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "ma-0 pa-0",
                                  attrs: { cols: "auto" },
                                },
                                [
                                  _c(
                                    "v-row",
                                    {
                                      staticClass: "ma-0 pa-0",
                                      staticStyle: {
                                        color: "#008DD0",
                                        "font-size": "0.8rem",
                                      },
                                      attrs: { align: "center" },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.tsc("viewAnalyze")) +
                                          " "
                                      ),
                                      _c("v-img", {
                                        staticClass: "ma-0 pa-0 ml-2",
                                        attrs: {
                                          "max-height": "0.8rem",
                                          "max-width": "0.8rem",
                                          src: require("@/assets/images/blue_right_icon.png"),
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "ma-0 pa-0",
                          attrs: { id: "data_people_box", cols: "12" },
                        },
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "ma-0 pa-0",
                              attrs: { align: "center" },
                            },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "ma-0 pa-1",
                                  attrs: { cols: "6" },
                                },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "ma-0 pa-0 pl-2",
                                      attrs: {
                                        id: "data_sub_title",
                                        cols: "12",
                                        align: "left",
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.t("all")))]
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "ma-0 pa-0 pl-2",
                                      attrs: {
                                        id: "data_count",
                                        cols: "12",
                                        align: "left",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.totalCount.total +
                                            _vm.tsc("peopleCount")
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "ma-0 pa-1",
                                  attrs: { cols: "6" },
                                },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "ma-0 pa-0 pl-2",
                                      attrs: {
                                        id: "data_sub_title",
                                        cols: "12",
                                        align: "left",
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.tsc("faceRecognition")))]
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "ma-0 pa-0 pl-2",
                                      attrs: {
                                        id: "data_count",
                                        cols: "12",
                                        align: "left",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.totalCount.known +
                                            _vm.tsc("peopleCount")
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "ma-0 pa-0 pr-2 pb-3",
                      staticStyle: { position: "relative" },
                      attrs: { cols: "12" },
                    },
                    [
                      _c("BarChart", {
                        attrs: {
                          "chart-data": _vm.visitorDataset,
                          options: _vm.chartOptions,
                          height: 75,
                        },
                      }),
                      _vm.fetchLoading === false &&
                      _vm.visitorDataset.datasets[0].data.length === 0
                        ? _c(
                            "v-col",
                            {
                              staticClass: "ma-0 pa-0",
                              attrs: { id: "no_data", cols: "12" },
                            },
                            [_vm._v(" " + _vm._s(_vm.t("noData")) + " ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.authorities.GET_RECORDING_SUB_BRANCH
            ? _c(
                "v-col",
                { staticClass: "ma-0 pa-0 pl-4", attrs: { cols: "9" } },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "ma-0 pa-0",
                      staticStyle: { cursor: "pointer" },
                      attrs: { id: "data_box", cols: "12" },
                      on: {
                        click: function ($event) {
                          return _vm.goStoreCCTV(_vm.item)
                        },
                      },
                    },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "ma-0 pa-3 pl-5 pr-5 pb-4",
                          attrs: { cols: "12" },
                        },
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "ma-0 pa-0 mb-1",
                              staticStyle: { "font-weight": "bold" },
                              attrs: {
                                align: "center",
                                justify: "space-between",
                              },
                            },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "ma-0 pa-0",
                                  attrs: { id: "data_sub_title", cols: "auto" },
                                },
                                [_vm._v(" " + _vm._s(_vm.tsc("camera")) + " ")]
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "ma-0 pa-0",
                                  attrs: { cols: "auto" },
                                },
                                [
                                  _c(
                                    "v-row",
                                    {
                                      staticClass: "ma-0 pa-0",
                                      staticStyle: {
                                        color: "#008DD0",
                                        "font-size": "0.8rem",
                                      },
                                      attrs: { align: "center" },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.tsc("viewCameras")) +
                                          " "
                                      ),
                                      _c("v-img", {
                                        staticClass: "ma-0 pa-0 ml-2",
                                        attrs: {
                                          "max-height": "0.8rem",
                                          "max-width": "0.8rem",
                                          src: require("@/assets/images/blue_right_icon.png"),
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.item.storeCameras != undefined &&
                          _vm.item.storeCameras.length != 0
                            ? _c(
                                "v-row",
                                { staticClass: "ma-0 pa-0" },
                                [
                                  _c(
                                    "v-row",
                                    {
                                      staticClass: "ma-0 pa-0",
                                      attrs: { align: "center" },
                                    },
                                    _vm._l(
                                      _vm.item.storeCameras,
                                      function (item_nest, index_nest) {
                                        return _c(
                                          "v-col",
                                          {
                                            key: index_nest,
                                            staticClass: "ma-0 pa-0 pr-1 pb-1",
                                            attrs: { cols: "3" },
                                          },
                                          [
                                            item_nest.thumbnail != undefined &&
                                            item_nest.isUas == false
                                              ? _c(
                                                  "v-img",
                                                  {
                                                    staticClass: "ma-0 pa-0",
                                                    staticStyle: {
                                                      background: "grey",
                                                    },
                                                    attrs: {
                                                      height: "8rem",
                                                      "max-width": "100%",
                                                      src: item_nest.thumbnail,
                                                    },
                                                    on: {
                                                      error: function ($event) {
                                                        return _vm.thumbnailError(
                                                          "no_data_box_" +
                                                            item_nest.unisCustomerCd +
                                                            "_" +
                                                            index_nest
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-col",
                                                      {
                                                        staticClass:
                                                          "ma-0 pa-0 no_data_box_style",
                                                        attrs: {
                                                          id:
                                                            "no_data_box_" +
                                                            item_nest.unisCustomerCd +
                                                            "_" +
                                                            index_nest,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.t("noData")
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : item_nest.thumbnail ==
                                                  undefined &&
                                                item_nest.isUas == false
                                              ? _c(
                                                  "v-col",
                                                  {
                                                    staticClass: "ma-0 pa-0",
                                                    staticStyle: {
                                                      height: "8rem",
                                                      "line-height": "8rem",
                                                      "text-align": "center",
                                                      background: "grey",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "p",
                                                      {
                                                        staticStyle: {
                                                          "white-space":
                                                            "pre-wrap",
                                                          "font-size":
                                                            "0.85rem",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.t(
                                                                "notStreaming"
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              )
                            : _c(
                                "v-row",
                                {
                                  staticClass: "ma-0 pa-0",
                                  staticStyle: { height: "8rem" },
                                  attrs: { align: "center", justify: "center" },
                                },
                                [_vm._v(" " + _vm._s(_vm.t("noData")) + " ")]
                              ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }